export const map = (
    value: number,
    inMin: number,
    inMax: number,
    outMin: number,
    outMax: number,
    shouldClampMin: boolean,
    shouldClampMax: boolean,
): number => {
    if (shouldClampMin && value <= inMin) {
        return outMin;
    }
    if (shouldClampMax && value >= inMax) {
        return outMax;
    }

    const inRange = inMax - inMin;
    if (inRange === 0) {
        return outMin;
    }

    const t = (value - inMin) / inRange;
    const mapped = outMin + t * (outMax - outMin);
    return mapped;
};

export const mapFrom0to1 = (
    value: number,
    outMin: number,
    outMax: number,
    shouldClampMin: boolean,
    shouldClampMax: boolean,
): number => map(value, 0, 1, outMin, outMax, shouldClampMin, shouldClampMax);

export const mapTo0to1 = (
    value: number,
    inMin: number,
    inMax: number,
    shouldClampMin: boolean,
    shouldClampMax: boolean,
): number => map(value, inMin, inMax, 0, 1, shouldClampMin, shouldClampMax);
